<template>
  <v-dialog v-model="visible" max-width="600px" persistent>
    <v-card class="mb-0">
      <v-card-title>
        <v-icon left>mdi-information</v-icon>
        Detalles del Partido
      </v-card-title>

      <v-card-text>
        <v-form @submit.prevent ref="form">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                ref="fecha"
                v-model="detalles.fecha"
                label="Fecha"
                placeholder="DD/MM/AAAA"
                type="date"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="detalles.fechaHasta"
                label="Fecha Hasta (opcional)"
                placeholder="DD/MM/AAAA"
                type="date"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="detalles.hora"
                label="Hora"
                placeholder="HH:MM"
                type="time"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="detalles.lugar"
                label="Lugar"
                placeholder="Complejo, cancha, etc"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="detalles.observaciones"
                label="Observaciones"
                rows="3"
                placeholder="Notas adicionales..."
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('close')" color="grey" dark>Cancelar</v-btn>
        <v-btn @click="guardar" color="success">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { showAlert } from "@/utils/toast";
import moment from "moment";

export default defineComponent({
  name: "EditarDetallesPartido",

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    partido: {
      type: Object,
      default: null,
    },
    proxy: {
      type: Object,
      default: null,
    },
  },

  emits: ["close", "save"],

  setup(props, { emit }) {
    // ⭐ IMPORTANTE: Inicializar detalles con valores por defecto
    const detalles = ref({
      fecha: "",
      fechaHasta: "",
      hora: "",
      lugar: "",
      observaciones: "",
    });

    const fecha = ref();

    // ⭐ Sincronizar detalles cuando cambia el partido
    watch(
      () => props.partido,
      (nuevoPartido) => {
        if (nuevoPartido) {
          // Si el partido tiene detalles existentes, copiarlos
          if (nuevoPartido.detalles) {
            detalles.value = {
              fecha: nuevoPartido.detalles.fecha
                ? moment(
                    nuevoPartido.detalles.fecha,
                    "DD/MM/YYYY",
                    true
                  ).format("YYYY-MM-DD")
                : "",
              fechaHasta: nuevoPartido.detalles.fechaHasta
                ? moment(
                    nuevoPartido.detalles.fechaHasta,
                    "DD/MM/YYYY",
                    true
                  ).format("YYYY-MM-DD")
                : "",
              hora: nuevoPartido.detalles.hora || "",
              lugar: nuevoPartido.detalles.lugar || "",
              observaciones: nuevoPartido.detalles.observaciones || "",
            };
          } else {
            // Si no tiene detalles, resetear a valores vacíos
            detalles.value = {
              fecha: "",
              fechaHasta: "",
              hora: "",
              lugar: "",
              observaciones: "",
            };
          }
        }
      },
      { immediate: true }
    );

    const guardar = () => {
      const isValid = moment(
        detalles.value.fecha,
        "YYYY-MM-DD",
        true
      ).isValid();
      console.log("fecha", detalles.value.fecha.toString());
      if (detalles.value.fecha && !isValid) {
        showAlert({
          title: "La fecha ingresada es incorrecta.",
          timer: 4000,
          vm: props.proxy,
          icon: "warning",
        });
        return;
      }

      if (
        detalles.value.hora &&
        !moment(detalles.value.hora, "HH:mm", true).isValid()
      ) {
        showAlert({
          title: "La hora ingresada es incorrecta.",
          timer: 4000,
          vm: props.proxy,
          icon: "warning",
        });
        return;
      }

      // Emitir todos los campos — los vacíos se envían como string vacío
      // para que el handler pueda detectar que fueron borrados
      const detallesParaGuardar: any = {
        fecha: detalles.value.fecha.trim()
          ? moment(detalles.value.fecha).format("DD/MM/YYYY")
          : "",
        fechaHasta: detalles.value.fechaHasta.trim()
          ? moment(detalles.value.fechaHasta).format("DD/MM/YYYY")
          : "",
        hora: detalles.value.hora.trim() || "",
        lugar: detalles.value.lugar.trim() || "",
        observaciones: detalles.value.observaciones.trim() || "",
      };

      emit("save", detallesParaGuardar);
    };

    return {
      detalles,
      guardar,
    };
  },
});
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-detalles {
  background: white;
  padding: 24px;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 12px;
}

.modal-header h3 {
  color: #4f46e5;
  margin: 0;
}

.btn-cerrar {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #6b7280;
  padding: 4px 8px;
  border-radius: 4px;
}

.btn-cerrar:hover {
  background: #f3f4f6;
  color: #374151;
}

.partido-info {
  text-align: center;
  margin-bottom: 20px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
  border-left: 4px solid #4f46e5;
}

.detalles-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-weight: 600;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 6px;
}

.form-group input,
.form-group textarea {
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.contador-caracteres {
  text-align: right;
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.btn-limpiar,
.btn-cancelar,
.btn-guardar {
  padding: 10px 20px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-limpiar {
  background: #fef2f2;
  color: #dc2626;
  margin-right: auto;
}

.btn-limpiar:hover {
  background: #fee2e2;
}

.btn-cancelar {
  background: #6b7280;
  color: white;
}

.btn-cancelar:hover {
  background: #4b5563;
}

.btn-guardar {
  background: #4f46e5;
  color: white;
}

.btn-guardar:hover {
  background: #4338ca;
}
</style>
